export default {
  "lead-list-autocomplete": "api/leads_list/",
  "task-calendar-list": "api/tasks_calendar/",
  "autocomplete-contacts": "api/contacts/",
  "autocomplete-users": "api/users/",
};



// WEBPACK FOOTER //
// ./src/Lib/Urls.js